<div class:bx--header__global="{true}">
  <slot />
</div>
